<script lang="ts" setup>

import { onMounted, ref } from 'vue';
import axiosInstance from '@/plugins/axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useRouter } from 'vue-router';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';

const translations = ref([]);
const showEditDialog = ref(false);
const selectedTranslation = ref({});
const router = useRouter();
const toast = useToast();
const confirm = useConfirm();

const getTranslations = async () => {
    try {
        const response = await axiosInstance.get('/admin/translations/all');
        translations.value = response.data;
    } catch (error) {
        console.log(error);
    }
}

const editTranslation = (sel: any) => {
    router.push({ name: 'TranslationDetailView', params: { id: sel._id } });
}

const confirmPopup = (event, id) => {
    confirm.require({
        target: event.currentTarget,
        message: 'Do you want to delete this translation?',
        icon: 'pi pi-info-circle',
        rejectProps: {
            label: 'Cancel',
            severity: 'secondary',
            outlined: true
        },
        acceptProps: {
            label: 'Delete',
            severity: 'danger'
        },
        accept: () => {
            deleteTranslation(id);
        },
        reject: () => {
            return;
        }
    });
};

const deleteTranslation = async (id: string) => {
    try {
        await axiosInstance.delete(`/admin/translations/${id}`);
        await getTranslations();
    } catch (error) {
        console.log(error);
    }
}

onMounted(async () => {
    await getTranslations();
});


</script>


<template>
    <div>
        <div class="row justify-content-center mb-3">
            <Button label="Add Translation" class="p-button-tuev w-30" @click="router.push({ name: 'TranslationDetailView', params: { id: 'new' } })">
                <template #icon>
                    <font-awesome-icon :icon="['fas', 'plus']" />
                </template>
            </Button>
        </div>
        <DataTable :value="translations" dataKey="id" paginator :rows="10">
            <Column field="languageIdentifier" header="Title"></Column>
            <Column field="active" header="Active"></Column>
            <Column field="createdAt" header="Created At">
                <template #body="slotProps">
                    {{ new Date(slotProps.data.createdAt).toLocaleString() }}
                </template>
            </Column>
            <Column header="Aktionen">
                <template #body="slotProps">
                    <Button @click="editTranslation(slotProps.data)" class="p-button-tuev">
                        <template #icon>
                            <font-awesome-icon :icon="['fas', 'edit']" />
                        </template>
                    </Button>
                    <Button @click="confirmPopup($event, slotProps.data._id)" class="p-button-danger ml-2">
                        <template #icon>
                            <font-awesome-icon :icon="['fas', 'trash']" />
                        </template>
                    </Button>
                </template>
            </Column>
        </DataTable>
    </div>
</template>